import React from 'react';
import SectionTitle from "../SectionTitles/SectionTitle";
import ChooseUsList from "../WhyChooseUs/ChooseUsList";
import AboutData from "../../data/About/about-one";
import AboutDataLocal from "../../data/About/about-one-local";
const currentUrl = window.location.href;
let content
if (currentUrl.includes("local.navysealsmoving")) {
    content = AboutDataLocal
} else {
    content = AboutData
}

// Mirrors the WhyChooseUs layout (same column width/position) so the two
// homepage sections align.
const SkillSec = () => {
    return (
    <section className="our-skill section">
        <div className="container">
            <div className="row">
                <div className="col-md-8 col-sm-12 why_chs">
                    {/* Heading */}
                    <SectionTitle
                        title="Our Services"
                    />
                    {/* End: Heading */}

                    {/*Start:   About List */}
                    {content.map(about=>(
                        <ChooseUsList
                            key={about.id}
                            title={about.title}
                            text={about.text}
                            icon={about.icon}
                        />
                    ))}
                    {/*End:  About List*/}

                </div>
            </div>
        </div>
    </section>
    );
};

export default SkillSec;
